import { unmarshalGraphqlEdges } from '~graphql/utils';

export const unmarshalGraphqlResponse = (
  response,
  key,
  removeEdgesAttr = false
) => {
  if (removeEdgesAttr) {
    if (typeof unmarshalGraphqlEdges(response[key]).edges !== 'undefined') {
      return unmarshalGraphqlEdges(response[key]).edges;
    }
  }
  return unmarshalGraphqlEdges(response[key], removeEdgesAttr);
};
